export const closeModal = () => {
  return {
    type: 'SET_INTERFACE_MODAL',
    payload: { isOpen: false, state: null },
  }
}

export const openModal = (payload) => {
  return {
    type: 'SET_INTERFACE_MODAL',
    payload: {
      isOpen: true,
      state: payload,
    },
  }
}
